import { useTranslation } from 'next-i18next'
import InfoCardWithButton from '@/components/entity/draw/cards/info-cards/with-button'
import { MoneyGoldIcon, MoneySilverIcon } from '@icons'
import styles from './styles.module.css'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { binder, path } from '@constants/router'
import { LOCUS_TYPES } from '@constants/definition'
import { getLocusWithRegistrationBonus } from '@utils/locus'

const DrawCards = () => {
  const { t } = useTranslation('draw')
  const { user } = useSelector(({ user }) => user)
  const pointsData = useMemo(() => {
    return getLocusWithRegistrationBonus(user.balance)
  }, [user.balance])
  const cards = useMemo(() => {
    return [
      {
        Icon: MoneyGoldIcon,
        count: pointsData?.goldPoints || 0,
        label: 'Gold Locus',
        btn: {
          text: t('draw::cards::topUp'),
          link: binder(path.PUBLICATION_LOCUS, { locus: LOCUS_TYPES.GOLD }),
        },
        link: { href: path.CABINET_PROMOCODE, text: t('draw::cards::enterPromocode') },
      },
      {
        Icon: MoneySilverIcon,
        count: pointsData?.silverPoints || 0,
        label: 'Silver Locus',
        btn: {
          text: t('draw::cards::topUp'),
          link: binder(path.PUBLICATION_LOCUS, { locus: LOCUS_TYPES.SILVER }),
        },
        link: {
          href: '/draw/apartments/convertation',
          text: t('draw::cards::convert'),
          info: t('draw::cards::convertInfo'),
        },
      },
      // TODO add if you need
      // {
      //   count: user?.tasksUncompleted || 0,
      //   label: t('draw::cards::tasks', { count: Number(user?.tasksUncompleted) || 0 }),
      //   btn: {
      //     text: t('draw::cards::earnLocus'),
      //     link: '/draw/tasks',
      //   },
      // },
    ]
  }, [t, user, pointsData])

  return (
    <div className={styles.cardsRow}>
      {cards.map((card) => (
        <div key={card.label} className={styles.infoCardWrapper}>
          <InfoCardWithButton card={card} />
        </div>
      ))}
    </div>
  )
}

export default DrawCards
